export const LorenGeofencingResolver = {
    circles: 'circles',
    polygons: 'polygons'
};
